import { Pipe, PipeTransform } from '@angular/core';
import {
  APP_MEDIA_SOURCE_BASES,
  resolveAppMediaSource,
} from '../utils/app-media-url.utils';
import type { MediaSourceType } from '../utils/media-url.utils';
import { appendImageTransform } from '../utils/media-url.utils';

@Pipe({
  name: 'mediaUrl',
  standalone: true,
})
export class MediaUrlPipe implements PipeTransform {
  public transform(
    source: string | null | undefined,
    mediaType: MediaSourceType = 'image',
    width?: number,
    height?: number
  ): string {
    const resolvedSource = resolveAppMediaSource(source, mediaType);

    if (width == null || height == null) {
      return resolvedSource;
    }

    return appendImageTransform(
      resolvedSource,
      width,
      height,
      resolvedSource.startsWith(APP_MEDIA_SOURCE_BASES.image)
    );
  }
}
